<template>
<div class="users">

    <ol class="breadcrumbs">
        <router-link to="/dashboard">Dashboard</router-link> > 
        <span v-if="orgUrl"> <router-link to="/organisations">Organisations</router-link> >   <router-link to="{ name: 'org-edit', params:{ id: org.url }}">{{org.name}}</router-link> > Users</span>
        <span v-if="!orgUrl"> Admin Users</span>

    </ol>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 v-if="!orgUrl" class="h3 mb-0 text-gray-800">Admin Users</h1>
        <h1 v-if="orgUrl" class="h3 mb-0 text-gray-800">{{org.name}} Users</h1>
    </div>
        <div v-if="error" class="mb-4 alert alert-danger">{{error}}</div>
        <div v-if="success" class="mb-4 alert alert-success">{{success}}</div>

    <table class="table table-striped table-bordered table-lg">
        <thead>
            <tr>
                <th>Name</th>
                <th>Created</th>
                <th>Color</th>
                <!--<<th>Collection</th>-->
                <th>Phone</th>
                <th>Email</th>
                <!--<<th>Alt Phone</th>-->

                <th>Role Name</th>
                <th>Role Level</th>
                <!--<th>Organisation</th>-->
                <!--<th>Accounts</th><th>Return</th><th>Attachment</th><th>Items</th>-->
            </tr>
        </thead>
        <tbody v-if="users && users.length > 0">
            <template v-for="(usr, index) in users">
                <router-link v-bind:class="{disable: usr.disabledDate}" class="rw" tag="tr" :to="{ name: 'user-view', params:{ id: usr['.key'] }}" v-bind:key="index">
                    <td :title="usr['.key']"><span v-html="$options.filters.getCaps(usr.name, usr['.key'], usr.colour)"></span> {{usr.name}}</td>
                    <td :time="user.created">{{usr.created | longDate}}</td>
                    <td>{{usr.colour}}</td>
                    <!--<td>{{job.collection}}</td>-->
                    <td>{{usr.phone}}</td>
                    <td>
                        <router-link :to="{ name: 'job-search', params: { email: usr.email } }">{{usr.email}}</router-link>
                    </td>
                    <td><span  v-if="!usr.disabledDate">{{usr.role | roleName}}</span><span v-if="usr.disabledDate">Disabled: {{usr.disabledDate | shortDate}}</span></td>
                    <td><span>{{usr.role}}</span></td>
                    <!--<td data-uid="usr.organisation">{{usr.organisationName}}</td>-->
                    <!--
                <td>{{job.accounts}}</td>
                <td>{{job.return}}</td>
                <td>{{job.attachment}}</td>
                <td><span v-for="(item, i) in job.items"  v-bind:key="i">{{item.description}}-{{item.quantity}}</span></td>-->
                </router-link>
            </template>
        </tbody>
    </table>
    <div v-if="org.name && users && users.length === 0" class="mb-4 alert alert-info">No Users setup for {{org.name}}</div>
    <div class="d-flex justify-content-center" v-if="user && user.data && user.data.role > 10 && !orgUrl">
        <router-link class="btn btn-primary" to="/new-user">Add New User</router-link>
    </div>
    <div class="d-flex justify-content-center" v-if="user && user.data && user.data.role > 10 && orgUrl">
        <router-link class="btn btn-primary" :to="{ name: 'org-new-user', params:{ orgId: org.url }}">Add New User</router-link>
    </div>

</div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
// Get a RTDB instance

import {
    db
} from '../main'

import {
    mapGetters
} from "vuex";

//const usersRef = db.ref("users");
import getOrganisation from "../mixins/getOrganisation";


export default {
    name: "Users",
    mixins: [getOrganisation],
    components: {
        // HelloWorld,
    },
    data() {
        return {
            usersRaw: [],
            limit: 50,
            error: null,
            success: null
        }
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
        users: function () {
            return [...this.usersRaw].reverse();
        }
    },
    firebase: {
        usersRaw: db.ref('users').orderByChild('name').limitToLast(50),
    },
    methods:{
    },
}
</script>
